import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ComponentRef, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { XMLElementBaseComponent } from '../../base';

@Component({
  selector: 'app-xml-table-block',
  imports: [CommonModule],
  standalone: true,
  template: `
    <div class="my-4 overflow-x-auto">
      <ng-template #childrenContainer></ng-template>

      <!-- <div class="bg-slate-50 text-xs">{{ data | json }}</div> -->
    </div>
  `,
})
export class TableBlockComponent extends XMLElementBaseComponent implements AfterViewInit, OnDestroy {
  @ViewChild('childrenContainer', { read: ViewContainerRef })
  childrenContainer!: ViewContainerRef;

  private childComponents: ComponentRef<XMLElementBaseComponent>[] = [];

  ngAfterViewInit() {
    this.childRenderService.setProvider(this.provider);
    const furtherChildren = this.data?.children?.filter((child: any) => !['wz'].includes(child.tag)) || [];
    this.childComponents = this.childRenderService.renderChildren(furtherChildren, this.childrenContainer);
  }

  ngOnDestroy() {
    this.childComponents.forEach((ref) => ref.destroy());
  }

  getTables() {
    if (this.data?.tag === 'tab-block') {
      return this.data.children.filter((child: any) => child.tag === 'tabelle');
    } else if (this.data?.tag === 'tabelle') {
      return [this.data];
    }
    return [];
  }
}
